import moment from "moment";

// ═══════════════════════════════════════════════════════════════════════════
// Live-review meeting time — show exactly what the backend sends.
//
// ⚠️ IDENTICAL COPY of the CEO app's `src/utils/meetingDateTime.js` (added
// 2026-10-09 so both apps print the same time for one session). Keep in step.
//
// ⚠️ `meeting_datetime` IS A WALL-CLOCK TIME, NOT AN INSTANT. The coach picks
// "Tue 6 Oct, 10:00" and the API stores it as `2026-10-06T10:00:00.000Z`. The
// trailing `Z` is not a real UTC marker — it is the coach's chosen time with a
// zero offset stamped on. Passing it through `new Date(iso)` / `moment(iso)`
// converted it to the viewer's zone, so an Indian CEO saw 3:30 PM for a 10:00
// session (+5:30), while the coach saw 10:00.
//
// `moment.parseZone` keeps the offset the string carries instead of converting
// it, so the hours and minutes on screen are the ones in the payload. The CEO
// and the coach now read the same time.
//
// For "is it today / has it passed" the wall-clock value is re-read as local
// time, so those checks compare like with like (the CEO's calendar day, the
// CEO's now) instead of an instant shifted by the zone.
// ═══════════════════════════════════════════════════════════════════════════

const asWallClock = (iso) => {
  if (!iso) return null;
  const parsed = moment.parseZone(iso);
  return parsed.isValid() ? parsed : null;
};

// The same wall-clock reading as a local moment, for comparisons with "now".
const asLocal = (iso) => {
  const wall = asWallClock(iso);
  return wall ? moment(wall.format("YYYY-MM-DDTHH:mm:ss")) : null;
};

// Format the meeting time as sent. `pattern` is a moment format string.
export const formatMeetingDateTime = (iso, pattern = "ddd, MMM D, hh:mm A") => {
  const wall = asWallClock(iso);
  return wall ? wall.format(pattern) : null;
};

export const isMeetingToday = (iso) => {
  const local = asLocal(iso);
  return !!local && local.isSame(moment(), "day");
};

export const isMeetingPast = (iso) => {
  const local = asLocal(iso);
  return !!local && local.isBefore(moment());
};
